import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

const PostListHelmet = ({ topic }) => {
  // useEffect(() => {
  //   console.log('[PostList SEO]', {
  //     name: topic?.name,
  //     slug: topic?.slug,
  //   });
  // }, [topic]);

  // console.log('[SEO Topic]', topic);
  // console.log('[topic?.slug]', topic?.slug);
  return (
    topic && (
      <Helmet key={topic?.slug || 'post-list'}>
        <title>{topic?.name || 'Bài viết'} | Thành Đồng</title>
        <meta
          name="description"
          content={`Danh sách các bài viết về chủ đề ${
            topic?.name || 'tổng hợp'
          } tại Công ty Thành Đồng. Chia sẻ kiến thức, hoạt động nội bộ và chuyên môn.`}
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Công ty Thành Đồng" />
        <meta
          name="keywords"
          content={`${
            topic?.name || 'tin tức'
          }, thành đồng, bài viết, vệ sinh, chống thấm`}
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`${topic?.name || 'Bài viết'} | Thành Đồng`}
        />
        <meta
          property="og:description"
          content={`Khám phá các bài viết thuộc chủ đề ${
            topic?.name || 'chung'
          } tại Thành Đồng. Nâng cao hiểu biết và cập nhật thông tin mới.`}
        />
        <meta property="og:image" content="https://thanhdongct.com/images/logo_thanh_dong.png" />
        <meta property="og:url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
    )
  );
};

export default PostListHelmet;
